/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CourseGradebookRenderWarningSizeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('COURSE_GRADEBOOK_RENDER_WARNING_SIZE')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class CourseGradebookRenderWarningSizeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CourseGradebookRenderWarningSizeSettingParser.decode(input).map(res => new CourseGradebookRenderWarningSizeSetting(res));
    }
    static unsafeDecode(input) {
        return CourseGradebookRenderWarningSizeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CourseGradebookRenderWarningSizeSettingParser.encode(data);
    }
    static schema() {
        return CourseGradebookRenderWarningSizeSettingParser.schema();
    }
}
